<template>
  <div class="param px">
    <template v-if="$route.path.includes('/dongle-mouse')">
      <div class="title">
        Dongle
        <md-switch class="md-primary" v-model="charSwitch"></md-switch>
      </div>
      <div class="param-item">
        <div class="name">{{ $t("mouse.effect") }}</div>
        <a-radio-group v-model="effect" class="radio-group">
          <a-radio v-for="i in 8" :key="i" class="radio" :value="i">
            {{ $t(`mouse.effects[${i}]`) }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item">
        <div class="name">{{ $t("mouse.speed") }}</div>
        {{ $t("slow") }}
        <a-slider
          class="slider"
          v-model="speed"
          :min="-4"
          :max="0"
          :tooltipVisible="false"
        />
        {{ $t("fast") }}
      </div>
      <div class="param-item">
        <div class="name">{{ $t("mouse.bright") }}</div>
        {{ $t("dark") }}
        <a-slider
          class="slider"
          v-model="bright"
          :min="0"
          :max="4"
          :tooltipVisible="false"
        />
        {{ $t("bright") }}
      </div>
      <div class="param-item" v-if="![0, 3].includes(effect)">
        <div class="name">{{ $t("mouse.color") }}</div>
        <a-radio-group v-model="option" class="radio-group">
          <a-radio v-for="i in 9" :key="i" class="radio" :value="i - 1">
            {{ $t(`mouse.options[${i - 1}]`) }}
          </a-radio>
        </a-radio-group>
      </div>
      <div class="param-item" v-if="option === 7 && ![0, 3].includes(effect)">
        <div class="name">{{ $t("mouse.customColor") }}</div>
        <c-slider
          class="color-slider"
          :value="color"
          :swatches="[]"
          @input="onColorInput"
          v-if="false"
        />
        <a-tooltip placement="right">
          <template slot="title">
            <sketch-picker
              class="picker"
              :value="color"
              disableAlpha
              @input="onColorInput"
              :preset-colors="[
                '#D0021B',
                '#F5A623',
                '#F8E71C',
                '#8B572A',
                '#7ED321',
                '#417505',
                '#BD10E0',
                '#9013FE',
                '#4A90E2',
                '#50E3C2',
                '#B8E986',
                '#000000',
                '#444444',
                '#888888',
                '#CCCCCC',
                '#FFFFFF',
              ]"
            />
          </template>
          <div class="color" :style="{ backgroundColor: color }"></div>
        </a-tooltip>
        <div class="num">
          {{ color }}
        </div>
      </div>
    </template>
    <div class="param-item" v-if="false">
      <div class="name">{{ $t("mouse.charLight") }}</div>
      <c-slider
        class="color-slider"
        :value="charLight"
        :swatches="[]"
        @input="onCharLightInput"
        v-if="false"
      />
      <a-tooltip placement="right">
        <template slot="title">
          <sketch-picker
            class="picker"
            :value="charLight"
            disableAlpha
            @input="onCharLightInput"
            :preset-colors="[
              '#D0021B',
              '#F5A623',
              '#F8E71C',
              '#8B572A',
              '#7ED321',
              '#417505',
              '#BD10E0',
              '#9013FE',
              '#4A90E2',
              '#50E3C2',
              '#B8E986',
              '#000000',
              '#444444',
              '#888888',
              '#CCCCCC',
              '#FFFFFF',
            ]"
          />
        </template>
        <div class="color" :style="{ backgroundColor: charLight }"></div>
      </a-tooltip>
      <div class="num">
        {{ charLight }}
      </div>
    </div>
    <br />
    <div class="title">
      {{ $t("mouse.name") }}
      <md-switch class="md-primary" v-model="charLightswitch"></md-switch>
    </div>
    <div class="param-item">
      <div class="name">{{ $t("mouse.charColor") }}</div>
      <c-slider
        class="color-slider"
        :value="charEndLight"
        :swatches="[]"
        @input="onCharEndLightInput"
        v-if="false"
      />
      <a-tooltip placement="right">
        <template slot="title">
          <sketch-picker
            class="picker"
            :value="charEndLight"
            disableAlpha
            @input="onCharEndLightInput"
            :preset-colors="[
              '#D0021B',
              '#F5A623',
              '#F8E71C',
              '#8B572A',
              '#7ED321',
              '#417505',
              '#BD10E0',
              '#9013FE',
              '#4A90E2',
              '#50E3C2',
              '#B8E986',
              '#000000',
              '#444444',
              '#888888',
              '#CCCCCC',
              '#FFFFFF',
            ]"
          />
        </template>
        <div class="color" :style="{ backgroundColor: charEndLight }"></div>
      </a-tooltip>
      <div class="num">
        {{ charEndLight }}
      </div>
    </div>
    <div class="button" @click="onSave" v-if="false">
      {{ $t("save") }}
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vueColor from "vue-color";

export default {
  name: "CMouseLight",
  components: {
    "sketch-picker": vueColor.Sketch,
  },
  data() {
    return {
      charSwitch: true, // 充电灯开关：0:关，1：开
      effect: 0, // 范围：0-8 含义：关闭/常亮/呼吸/霓虹/光波/跑马/圆环/缓冲/追捕
      speed: 0, // 范围：0-4 含义：灯光速度
      bright: 0, // 范围：0-4 含义：灯光亮度
      option: 0, // 范围：0-8 含义：对应红、橙、黄、绿、青、蓝、紫、自定义、炫彩模式
      color: "#FFFFFF", // 范围：0-255 含义：RGB颜色
      charLightswitch: true, // 充电灯开关：0:关，1：开
      charLight: "#FFFFFF", // 充电中灯效
      charEndLight: "#FF00FF", // 满电灯效
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("mouse", {
      param: "param",
    }),
  },
  methods: {
    onCharLightInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.charLight = color.length === 7 ? color : "#000000";
    },
    onCharEndLightInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.charEndLight = color.length === 7 ? color : "#000000";
    },
    onColorInput(e) {
      const color = e.hex ? e.hex : "#" + e.target.value;
      this.color = color.length === 7 ? color : "#000000";
    },
    onReset() {
      (this.effect = 0),
        (this.speed = 0),
        (this.bright = 0),
        (this.option = 0),
        (this.color = "#FFFFFF");
      this.onSave();
    },
    onSave() {
      const light = {
        charSwitch: this.charSwitch ? 1 : 0,
        effect: this.effect,
        speed: Math.abs(this.speed),
        bright: this.bright,
        option: this.option,
        color: this.color.match(/\w\w/g).map((c) => parseInt(c, 16)),
      };

      const param = {
        ...this.param,
        charLight: this.charEndLight.match(/\w\w/g).map((c) => parseInt(c, 16)),
        charEndLight: this.charEndLight
          .match(/\w\w/g)
          .map((c) => parseInt(c, 16)),
        charLightswitch: this.charLightswitch ? 1 : 0,
      };
      this.$store.dispatch("loader/setMouseInfo", param).then(() => {
        // this.$message.info(this.$t("loader.saveSuccess"));
      });
      this.$store.dispatch("mouse/setParam", param);
      this.$store.dispatch("mouse/setLight", light);
      this.$store.dispatch("loader/setMDLight", light);
    },
  },
  mounted() {
    this.$store.dispatch("loader/getMDLight");
    window.updateMDLight = (json) => {
      if (json) {
        console.log("updateMDLight", json);
        const data = JSON.parse(json);
        this.charSwitch = data.charSwitch > 0;
        this.effect = data.effect;
        this.speed = data.speed * -1;
        this.bright = data.bright;
        this.option = data.option;
        this.color = `#${data.color
          .map((c) => c.toString(16).padStart(2, "0"))
          .join("")}`.toUpperCase();
        console.log("updateMDLight", "true");
        this.$store.dispatch("mouse/setLight", {
          charSwitch: this.charSwitch ? 1 : 0,
          effect: this.effect,
          speed: Math.abs(this.speed),
          bright: this.bright,
          option: this.option,
          color: this.color.match(/\w\w/g).map((c) => parseInt(c, 16)),
        });
      }
    };
    const data = this.param;
    this.charLight = `#${data.charEndLight
      .map((c) => c.toString(16).padStart(2, "0"))
      .join("")}`.toUpperCase();
    this.charEndLight = `#${data.charEndLight
      .map((c) => c.toString(16).padStart(2, "0"))
      .join("")}`.toUpperCase();
    this.charLightswitch = data.charLightswitch > 0;

    let timer = 0;
    this.$watch(
      "$data",
      function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(this.onSave, 200);
      },
      { deep: true }
    );
  },
};
</script>
<style lang="scss" scoped>
.param {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 1200px;
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .param-item {
    @include flex-center;
    width: 1200px;
    justify-content: flex-start;
    padding: 15px 0;
    font-size: 20px;

    .name {
      margin-right: 20px;
    }

    .slider {
      width: 300px;
      margin: 0 20px;
    }

    .radio-group {
      @include flex-center;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        margin-right: 5px;
      }
    }

    .color {
      width: 60px;
      height: 25px;
      border: 1px solid $primary-color;

      & + .num {
        margin-left: 20px;
      }
    }

    .num,
    .tip {
      width: 80px;
      font-size: 20px;
      margin: 0 40px 0 0;
      padding: 0;
      white-space: nowrap;

      .number-input {
        width: 100%;
        text-align: center;
      }
    }

    .tip {
      width: auto;
      font-size: 16px;
      color: #cccccc;
    }
  }

  .button {
    @include button;
    width: 120px;
    height: 34px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    &:hover {
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss">
.param {
  .slider {
    padding: 4px 0;
    .ant-slider-rail {
      height: 4px;
      background-color: #717171 !important;
    }

    .ant-slider-track {
      height: 4px;
      background-color: $primary-color !important;
    }

    .ant-slider-step {
      height: 4px;
    }

    .ant-slider-handle {
      width: 20px;
      height: 20px;
      margin-top: -7px;
      background-color: $primary-color !important;
      border: 0;
      box-shadow: none;
    }
  }

  .ant-radio-group .radio {
    background: #101010;
    border-radius: 5px;
    padding: 0 2px 0 12px;
    margin-right: 12px;

    .ant-radio {
      margin-right: 5px;

      .ant-radio-inner {
        border-color: $primary-color;

        &::after {
          background-color: $primary-color;
        }
      }
    }

    &.ant-radio-wrapper-checked,
    &:hover {
      color: $primary-color;
    }
  }

  .md-switch.md-theme-default.md-checked.md-primary .md-switch-container {
    background-color: rgb(0, 200, 0);
  }

  .color-slider {
    .vc-slider-hue-warp {
      height: 10px;

      .vc-hue-pointer {
        margin-top: -5px;
      }
    }
  }
}

.ant-tooltip-inner {
  color: #000000;

  .vc-editable-input input {
    text-align: center;
  }
}
</style>
